import React from "react";
import type { KgDatabaseIconProps } from "./KgDatabaseIcon.types";

/** Database cylinder icon for data source nodes (16px). */
export const KgDatabaseIcon: React.FC<KgDatabaseIconProps> = ({
  size = 16,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M8 5.33398C11.3137 5.33398 14 4.43855 14 3.33398C14 2.22941 11.3137 1.33398 8 1.33398C4.68629 1.33398 2 2.22941 2 3.33398C2 4.43855 4.68629 5.33398 8 5.33398Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 3.33398V12.6673C2 13.1978 2.63214 13.7065 3.75736 14.0815C4.88258 14.4566 6.4087 14.6673 8 14.6673C9.5913 14.6673 11.1174 14.4566 12.2426 14.0815C13.3679 13.7065 14 13.1978 14 12.6673V3.33398"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 8C2 8.53043 2.63214 9.03914 3.75736 9.41421C4.88258 9.78929 6.4087 10 8 10C9.5913 10 11.1174 9.78929 12.2426 9.41421C13.3679 9.03914 14 8.53043 14 8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KgDatabaseIcon;
